<template>
	<div class="main">
		<ul id="dormitoryTypeNav" class="nav nav-tabs" role="tablist" v-show="isAdmin('stay')">
			<li class="" data-apply-type="N" role="presentation" v-if="normalIsOpen" >
				<a data-toggle="tab" @click="selectionDoemitoryType('N')">一般宿舍</a>
			</li>
			<li class="" data-apply-type="V" role="presentation" v-if="vacationIsOpen" >
				<a data-toggle="tab" @click="selectionDoemitoryType('V')">寒暑假宿舍</a>
			</li>
			<li class="" data-apply-type="S" role="presentation" v-if="specialIsOpen" >
				<a data-toggle="tab" @click="selectionDoemitoryType('S')">特殊原因宿舍</a>
			</li>
		</ul>
		<section class="panel panel-default" style="margin-bottom: 0px;">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">查詢條件</h4>
			</header>
			<div id="searchArea" class="panel-collapse collapse">
				<div class="panel-body">
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4" v-if="dormitoryType == 'N'">
								<label class="col-md-4">學期</label>
								<div class="col-md-8">
									<select v-model="smtr" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(year, index) in selectYear()" :key="index" :value="year.value" :selected="index == 0">{{year.text}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4" v-else>
								<label class="col-md-4">學年</label>
								<div class="col-md-8">
									<select v-model="smtr" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(year, index) in selectYear()" :key="index" :value="year.value">{{year.text}}</option>
									</select>
								</div>
							</div>

							<div class="col-md-4">
								<label class="col-md-4">學號</label>
								<div class="col-md-8">
									<input type="text" class="form-control" v-model="account" />
								</div>
							</div>

						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4">
								<label class="col-md-4">宿舍</label>
								<div class="col-md-8">
									<input type="text" class="form-control" v-model="bedFloor" />
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">寢室</label>
								<div class="col-md-8">
									<input type="text" class="form-control" v-model="bedRoom" />
								</div>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-offset-4 col-md-4 ">
							<div class="col-md-offset-4 col-md-4">
								<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<div class="tab-content">
			<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
				<div class="row form-group">
					<div class="col-md-12 text-right form-inline" v-if="isAdmin('stay')">
						<div class="col-md-6"></div>
						<div class="col-md-6">
							<button class="btn btn-danger hidden-xs" @click="exportExcel">資料匯出</button>
							<button class="btn btn-danger btn-block visible-xs" @click="exportExcel">資料匯出</button>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 form-group">
						<table class="table table-no-more table-bordered table-striped mb-none" style="width:100% !important;">
							<thead>
								<tr>
									<th class="text-center" style="width:10%">學期</th>
									<th class="text-center" style="width:15%">學制</th>
									<th class="text-center" style="width:20%">系科年級</th>
									<th class="text-center" style="width:10%">學號</th>
									<th class="text-center" style="width:10%">姓名</th>
									<th class="text-center" style="width:15%">宿舍床位</th>
									<th class="text-center" style="width:20%">電腦mac位置</th>
								</tr>
							</thead>
							<tbody v-for="(item, index) in roomApplyList.rows" :key="index">
								<tr>
									<td class="text-center" data-title="學期">{{item.smtr}}</td>
									<td class="text-center" data-title="學制">{{item.deptSsymStr}}</td>
									<td class="text-center" data-title="系科年級">{{item.deptCodeStr}}<br/>{{item.drade}}年{{item.dradeClass}}班</td>
									<td class="text-center" data-title="學號">{{item.account}}</td>
									<td class="text-center" data-title="姓名">{{item.name}}</td>
									<td class="text-center" data-title="宿舍床位" >
										<span v-if="item.bedRoom !== null">{{item.bedFloor}}-{{item.bedRoom}}-{{item.bed}}-{{item.bedCategory}}</span>
									</td>
									<td class="text-center" data-title="電腦mac位置" >
										<a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" @click="gotoView('stay.intoRoomData', { dormitoryType: item.dormitoryType, smtr: item.smtr, idno: item.idno, account: item.account, id:item.id })">{{item.macAddr}}</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-12">
						<div class="text-center">
							<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dormitoryType: "N",
			arimId: "",
			normalIsOpen: true,
			vacationIsOpen: true,
			specialIsOpen: true,
			isDefault: true,
			importExcelFile: "",
			accountType: "",
			quitProveView: true,
			roomApplyList: {},
			quitProveFile: null,
			bed: "",
			bedList: [],
			account: "",
			smtr: "",
			idno: "",
			bedFloor:"",
			bedRoom:"",
			page: 1,
			totalPage: 1,
			isOpenBillingInvoice:false,
			popupParam:{
				idno:"",
				account:"",
				smtr:"",
				dormitoryType:""
			},
		};
	},
	mounted() {
		let _this = this;
		if (this.sessionData == null) {
			_this.$router.replace({ path: "/" });
		}
    //套用查詢設定
    const storeQryParam = JSON.parse(this.getStore(`${this.$route.name}.qryParam`));

    if(storeQryParam != null) {
      this.dormitoryType = storeQryParam.dormitoryType;
      this.bedFloor = storeQryParam.bedFloor;
      this.bedRoom = storeQryParam.bedRoom;
      this.smtr = storeQryParam.smtr;
      this.account = storeQryParam.account;
    }
    const storePage = this.getStore(`${this.$route.name}.page`);
    if(storePage != null) {
      this.page = storePage;
    }

    switch (this.dormitoryType) {
      case "V":
        document.querySelector("[id='dormitoryTypeNav']").children[1].classList.add("active");
        break;
      case "S":
        document.querySelector("[id='dormitoryTypeNav']").children[2].classList.add("active");
        break;
      case "N":
      default:
        document.querySelector("[id='dormitoryTypeNav']").children[0].classList.add("active");
        break;
    }

		_this.selectionDoemitoryType(this.dormitoryType, false);
	},
	methods: {
		selectionDoemitoryType(dormitoryType, clearQueryParam = true) {
			this.dormitoryType = dormitoryType;
      if(clearQueryParam){
        this.bedFloor = "";
        this.bedRoom = "";
        this.account = "";
        if(this.dormitoryType == "N"){
          this.smtr = this.nowSmtr;
        }else {
          this.smtr = `${this.nowSyear}`
        }
      } else {
        if(this.dormitoryType == "N" && (this.smtr.length != 4)){
          this.smtr = this.nowSmtr;
        }else if ((this.dormitoryType == "V" || this.dormitoryType == "S" ) && this.smtr.length != 3) {
          this.smtr = `${this.nowSyear}`
        }
      }
			this.loadGrid();
		},
		loadGrid(){
			let qryParam = {
				dormitoryType: this.dormitoryType,
				smtr: this.smtr,
				account: this.account,
				bedFloor :this.bedFloor,
				bedRoom: this.bedRoom,
				applyStatus: "Y",
				qualification: "Q",
				writeOffStatus:"Y",
				isLeave:"N",
				quitProve:"N",
			};

			const api = "/api/Room/roomApplyList";
			let _this = this;
			this.$axios.post(api, JSON.stringify({
				model:qryParam,
				page: this.page,
				pageSize: 10,
				sortColumn:"BED_FLOOR, BED_ROOM, BED, BED_CATEGORY"
			})).then(resp => {
				_this.roomApplyList = resp.data.data;
				_this.totalPage = _this.roomApplyList.total;
				_this.page = _this.roomApplyList.page;
			});
		},
		setDoemitoryType(dormitoryType) {
			this.dormitoryType = dormitoryType;
		},
		updateGrid(page) {
			this.page = page;
			this.loadGrid();
		},

		exportExcel() {
			const api = "/api/Room/exportRoomData";
			this.$axios.post( api, JSON.stringify({
				dormitoryType: this.dormitoryType,
				qualification: "Q",
				applyStatus: "Y",
				writeOffStatus: "Y",
				isLeave:"N",

			}), {
				headers: { "Content-Type": "application/json" },
				responseType: "blob"
			}).then(resp => {
				const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "入宿資料_"+this.customFormatter(new Date())+".xlsx");
				document.body.appendChild(link);
				link.click();
			});
		},

		isIntoRoom(item){
			return this.nowSmtr == item.smtr && item.dormitoryType == this.dormitoryType && item.writeOffStatus == "Y";
		},
		getDormitoryTypeStr(dormitoryType){
			let str = "";
			if(dormitoryType == "N"){
				str = "一般宿舍";
			}else if(dormitoryType == "S"){
				str = "特殊宿舍";
			}else if(dormitoryType == "V"){
				str = "寒暑假宿舍";
			}
			return str;
		},
		selectYear(){
			let smtrArray = [];
			let nowYear = (new Date().getFullYear() - 1911);
			let nowMonth = new Date().getMonth() + 1;
			if(nowMonth < 8){
				nowYear = nowYear-1;
			}
			for(let y = nowYear; y > 107 ; y--){
				if(this.dormitoryType == "N"){
					smtrArray.push({text:y+"年第二學期",value:y+"2"});
					smtrArray.push({text:y+"年第一學期",value:y+"1"});
				}else{
					smtrArray.push({text:y+"年",value:`${y}`});
				}
			}
			return smtrArray;
		},
	},
	computed: {
		isDataExists() {
			let result = false;
			if (this.roomApplyList.rows && this.roomApplyList.rows.length > 0) {
				result = true;
			}
			return result;
		}
  },
  beforeRouteLeave(to, from, next) {
    //保留查詢設定
    if(to.name === "stay.intoRoomData") {
      this.setStore(`${this.$route.name}.qryParam`, {
        dormitoryType: this.dormitoryType,
        smtr: this.smtr,
        account: this.account,
        bedFloor :this.bedFloor,
        bedRoom: this.bedRoom
      });
      this.setStore(`${this.$route.name}.page`, this.page);
    } else {
      this.removeStore(`${this.$route.name}.page`);
      this.removeStore(`${this.$route.name}.qryParam`);
    }
    this.removeStore(this.$route.name);
    next();
  }
};
</script>
